import './styles.scss'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COFFEE_WEB_EXPO_DIGITAL, COFFEE_WEB_EXPO_PHYSICAL } from 'Utils/Constants'

const CoffeeApps = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState('digital')

  return (
    <div className="coffee-exchange-container">
      <div className={`expo-tabs ${activeTab}`}>
        <div className="expo-tab-indicator" />

        <button type="button" className={`expo-tab-button ${activeTab === 'digital' ? 'active' : ''}`} onClick={() => setActiveTab('digital')}>
          {t('DIGITAL_EXPO')}
        </button>

        <button type="button" className={`expo-tab-button ${activeTab === 'physical' ? 'active' : ''}`} onClick={() => setActiveTab('physical')}>
          {t('PHYSICAL_EXPO')}
        </button>
      </div>

      {activeTab === 'digital' && (
        <video controls className="exchange-video" autoPlay loop playsInline>
          <source src={COFFEE_WEB_EXPO_DIGITAL.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {activeTab === 'physical' && (
        <video controls className="exchange-video" autoPlay loop playsInline>
          <source src={COFFEE_WEB_EXPO_PHYSICAL.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  )
}

export default CoffeeApps
